<template>
  <div>
    <div class="centro">
      <div class="titulo-pagina">
        <div class="triangulo-play"></div>
        <h1><span>ATO INFRALEGAL</span></h1>
      </div>
      <BuscaSimplesCards
        titulo="Consultas Rápidas"
        :cards="cardsAtoInfralegal"
      />
    </div>
    <div
      class="pesquise"
      v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
    >
      <div class="centro">
        <div>
        <div class="header-pesquisa">
          <h2>PESQUISE AQUI</h2> 
            </div>
          <div class="linha-input-operadores">
            <div class="item row1">
              <InputSemantico v-model="semantico" :statusNorma="statusNorma" />
              <BuscaSimples
                v-if="this.semantico && !this.exibirPesquisaAvancada"
                v-model="termo"
                contexto="Descreva o que você procura sobre ato infralegal. Ex: 'Ato infralegal sobre meio ambiente'"
                :semantico="true"
                @busca-simples="fazerBuscaSimples"
              />
              <BuscaSimples
                v-else-if="!this.exibirPesquisaAvancada"
                v-model="termo"
                contexto="Digite o número ou texto do ato infralegal"
                :semantico="false"
                @busca-simples="fazerBuscaSimples"
              />
            </div>
            <div class="lado-direito">
              <OperadoresBusca
                v-show="!semantico && !this.exibirPesquisaAvancada"
                @adicionar-operador="adicionarOperadorTermo"
              />
              <div class="botao">
                <button type="button" @click="tooglePesquisaAvancada">
                  PESQUISA AVANÇADA
                  <span>
                    <template v-if="!exibirPesquisaAvancada">&#9660;</template>
                    <template v-else>&#9650;</template>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <transition name="slide">
            <form
              v-if="exibirPesquisaAvancada"
              @submit.prevent="fazerBuscaAvancada"
              @keydown.enter.prevent="fazerBuscaAvancada"
            >
              <div class="avancado">
                <div class="row2">
                  <div class="item">
                    <label>Tipo</label>
                    <div
                      v-if="isMobile"
                      class="mobile-multiselect-trigger"
                      @click="abrirTipoMobileDropdown"
                    >
                      <span v-if="tiposSelecionados.length === 0"
                        >Escolha opções...</span
                      >
                      <span
                        v-else-if="tiposSelecionados.length === 1"
                        class="tipo-nome-unico"
                        >{{ tiposSelecionados[0].nome }}</span
                      >
                      <span v-else
                        >{{ tiposSelecionados.length }} selecionados</span
                      >
                    </div>
                    <multiselect
                      v-else
                      v-model="tiposSelecionados"
                      :options="tipos_atos_infralegais"
                      :multiple="true"
                      :taggable="true"
                      :searchable="true"
                      :show-labels="false"
                      placeholder="Escolha opções..."
                      label="nome"
                      track-by="id"
                    ></multiselect>
                  </div>
                  <div class="row2mobile">
                    <div class="item">
                      <label>Nº do Ato Infralegal</label>
                      <input type="text" v-model="filtro.numero" />
                    </div>
                    <div class="item">
                      <label>Ano do Ato Infralegal</label>
                      <input type="number" v-model="filtro.ano" />
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="grupo">
                    <p>Data do Ato Infralegal</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_data"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_data"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="grupo">
                    <p>Data de início da vigência</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_vigencia_inicio"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_vigencia_fim"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="grupo">
                    <p>Data do fim da vigência</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_final_vigencia_inicio"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_vigencia_fim"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label>Órgão Emissor</label>
                    <div
                      v-if="isMobile"
                      class="mobile-multiselect-trigger"
                      @click="abrirOrgaoMobileDropdown"
                    >
                      {{
                        orgaoSelecionado
                          ? orgaoSelecionado.nome
                          : "Escolha opções..."
                      }}
                    </div>
                    <multiselect
                      v-else
                      v-model="orgaoSelecionado"
                      :options="orgaos_atos_infralegais"
                      :multiple="false"
                      :taggable="true"
                      :searchable="true"
                      :show-labels="false"
                      placeholder="Escolha opções..."
                      label="nome"
                      track-by="id"
                    ></multiselect>
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <div class="gridbox-1">
                      <div class="input">
                        <label>Texto</label>
                        <input
                          id="inputTexto"
                          type="text"
                          :placeholder="
                            this.semantico
                              ? `Descreva o que você procura. Ex: 'Atos sobre aditivos de contratos'`
                              : ''
                          "
                          v-model="filtro.conteudo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <label>Ementa</label>
                    <input type="text" v-model="filtro.ementa" />
                  </div>
                  <div class="item"></div>
                  <div></div>
                  <div class="botoes">
                    <button
                      title="Limpar"
                      @click="limparFiltro()"
                      type="button"
                    >
                      Limpar
                    </button>
                    <button type="submit">Buscar</button>
                  </div>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <!-- <div class="seta">
          <img
            src="../../assets/images/triangulo-form.png"
            class="triangulo t-branco"
            alt=" "
          />
          <img
            src="../../assets/images/triangulo-form-black.png"
            class="triangulo t-preto"
            alt=" "
          />
        </div> -->
      </div>
    </div>
    <div class="centro campo-resultados" id="resultados">
      <div class="nav-resultados">
        <div class="first-flex">
          <h2 ref="resultadosTitulo" tabindex="-1">RESULTADOS DA PESQUISA</h2>
          <div
            class="dados-abertos"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <span>Dados Abertos:</span>
              <a @click="abrirDadosAbertos('json')">JSON</a>
              <a @click="abrirDadosAbertos('csv')">CSV</a>
            </p>
          </div>
        </div>
        <div class="second-flex">
          <ParametrosBusca
            :funcaoBuscaSimples="fazerBuscaSimples"
            :funcaoBuscaAvancada="fazerBuscaAvancada"
            :funcaoRemoveItemFiltro="removerItemFiltro"
            :termo="termo"
            :tipos="tipos_atos_infralegais"
            :orgaos="orgaos_atos_infralegais"
            :setores="setores_atos_infralegais"
            :filtro="filtro"
            :semantico="semantico"
            @update:semantico="semantico = $event"
            contexto="ato_infralegal"
            v-show="!carregando && !carregandoFiltros && !erro && !erroFiltros"
          />
        </div>
        <div class="third-flex">
          <div
            class="nresultados"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <strong>{{ totalResultadosTexto }}</strong>
              {{
                totalResultadosTexto === 1
                  ? ` resultado encontrado`
                  : ` resultados encontrados`
              }}
            </p>
          </div>
          <div class="npagina" v-show="!carregando && !carregandoFiltros">
            <label>Resultados por Página</label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <TabelaResultadosAtoInfralegal
          :atosInfralegais="atosInfralegais"
          v-if="!carregando && !carregandoFiltros && !erro && !erroFiltros"
        ></TabelaResultadosAtoInfralegal>

        <Loading v-if="carregando"></Loading>
        <ErroResultados
          v-if="!carregando && !carregandoFiltros && (erro || erroFiltros)"
        ></ErroResultados>

        <paginate
          v-if="!erro && !carregando && !carregandoFiltros && !erroFiltros"
          v-model="pagina"
          :page-count="pageCount"
          :click-handler="mudouPagina"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'className'"
          active-class="active-page"
        ></paginate>
      </div>
    </div>
    <div
      v-if="showTipoMobileDropdown"
      class="mobile-dropdown-modal"
      @click.self="closeTipoMobileDropdown"
    >
      <div class="mobile-dropdown-content">
        <ul class="mobile-dropdown-list">
          <li
            v-for="option in tipos_atos_infralegais"
            :key="option.id"
            @click="toggleTipoSelecionado(option)"
            :class="{
              selected: tiposSelecionadosMobile.some(
                (sel) => sel.id === option.id
              ),
            }"
          >
            <input
              type="checkbox"
              :checked="
                tiposSelecionadosMobile.some((sel) => sel.id === option.id)
              "
              @change.prevent
            />
            {{ option.nome }}
          </li>
        </ul>
        <button class="mobile-dropdown-apply" @click="aplicarTipoSelecionados">
          Aplicar
        </button>
      </div>
    </div>
    <div
      v-if="showOrgaoMobileDropdown"
      class="mobile-dropdown-modal"
      @click.self="closeOrgaoMobileDropdown"
    >
      <div class="mobile-dropdown-content">
        <ul class="mobile-dropdown-list">
          <li
            v-for="option in orgaosFiltradosMobile"
            :key="option.id"
            @click="selectOrgaoOption(option)"
            :class="{
              selected:
                orgaoSelecionadoMobile &&
                orgaoSelecionadoMobile.id === option.id,
            }"
          >
            {{ option.nome }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// Bibliotecas
import { format, parseISO } from "date-fns";
import Paginate from "vuejs-paginate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import Multiselect from "vue-multiselect";

// Componentes
import TabelaResultadosAtoInfralegal from "../../components/pesquisa_ato_infralegal/TabelaResultadosAtoInfralegal";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import ParametrosBusca from "../../components/ParametrosBusca";
import BuscaSimples from "../../components/BuscaSimples.vue";
import OperadoresBusca from "../../components/OperadoresBusca.vue";
import BuscaSimplesCards from "../../components/BuscaSimplesCards.vue";
import InputSemantico from "../../components/InputSemantico.vue";

// API, Mixins e helpers
import AtoInfralegalApi from "../../services/AtoInfralegalApi";
import TipoAtoInfralegalApi from "../../services/TipoAtoInfralegalApi";
import CategoriaAtoInfralegalApi from "../../services/CategoriaAtoInfralegalApi";
import OrgaoAtoInfralegalApi from "../../services/OrgaoAtoInfralegalApi";
import { datepickerFormatter } from "../../helpers/datepickerFormatter";
import { mixinAtoInfralegal } from "../../mixins/mixinAtoInfralegal";
import tryParseInt from "../../helpers/tryParseInt";
import metaDados from "../../helpers/metaDados";

export default {
  name: "PesquisaAtoInfralegal",
  metaInfo() {
    return {
      title: "Pesquisa de Ato Infralegal",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Pesquisa a Legislação - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: "Pesquisa a Legislação - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinAtoInfralegal],
  props: {
    orgaoSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // Instâncias das APIs são inicializadas aqui para garantir que sempre existam
      atoInfralegalApi: null,
      tipoAtoInfralegalApi: null,
      categoriaAtoInfralegalApi: null,
      orgaoAtoInfralegalApi: null,

      atosInfralegais: [],
      maisRecentes: [],
      carregandoMaisRecentes: true,
      erroMaisRecentes: false,
      carregando: true,
      erro: false,
      totalResultados: null,
      totalResultadosTexto: null,
      pagina: 1,
      qtd_por_pagina: 10,
      termo: null,
      filtro: {
        numero: null,
        conteudo: null,
        tipo_ato_infralegal: [],
        orgao_emissor: null, // Será preenchido com o ID do órgão
        setor: null, // Unidade Responsável (id do setor), vem da consulta por órgão
        ano: null,
        periodo_inicial_data: null,
        periodo_final_data: null,
        periodo_inicial_vigencia_inicio: null,
        periodo_final_vigencia_inicio: null,
        periodo_inicial_vigencia_fim: null,
        periodo_final_vigencia_fim: null,
        ementa: null,
      },
      carregandoFiltros: true,
      erroFiltros: false,
      tipos_atos_infralegais: [],
      tiposSelecionados: [],
      orgaos_atos_infralegais: [],
      orgaos_atos_infralegais_filtrados: [],
      orgaoSelecionado: null,
      setores_atos_infralegais: [],
      exibirPesquisaAvancada: tryParseInt(this.getParam("busca_avancada")) == 1,
      datepickerFormatter,
      statusNorma: "",
      semantico: null,
      tiposSelecionadosMobile: [],
      showTipoMobileDropdown: false,
      orgaoSelecionadoMobile: null,
      showOrgaoMobileDropdown: false,
      orgaoFiltroTexto: "",
      isMobile: window.innerWidth < 600,
    };
  },
  components: {
    TabelaResultadosAtoInfralegal,
    Paginate,
    DatePicker,
    Multiselect,
    Loading,
    ErroResultados,
    ParametrosBusca,
    OperadoresBusca,
    BuscaSimples,
    BuscaSimplesCards,
    InputSemantico,
  },
  async created() {
    // Inicializa todas as instâncias das APIs AQUI para garantir que existam
    this.atoInfralegalApi = new AtoInfralegalApi();
    this.tipoAtoInfralegalApi = new TipoAtoInfralegalApi();
    this.categoriaAtoInfralegalApi = new CategoriaAtoInfralegalApi();
    this.orgaoAtoInfralegalApi = new OrgaoAtoInfralegalApi();
    this.checarStatusNorma();

    // O restante da lógica de carregamento será tratada pelo `watch`
    // porque ele tem `immediate: true` e será disparado logo após o created.
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 600;
    });

    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollParaResultados();
        }, 500);
      });
    }
  },
  watch: {
    $route: {
      immediate: true, // Garante que seja executado na montagem inicial e em todas as mudanças de rota
      handler: async function (to, from) {
        // Verifica se a rota mudou de forma significativa para disparar uma nova busca
        const mudouQuery = JSON.stringify(to.query) !== JSON.stringify(from ? from.query : {});
        const mudouParamOrgao = to.params.orgaoSlug !== (from ? from.params.orgaoSlug : undefined);

        // Se houver uma mudança de rota ou se é a carga inicial
        if (mudouQuery || mudouParamOrgao || !from) {
          // Limpa os filtros antes de carregar os novos, para evitar estado sujo
          this.limparFiltro(false); // Chama limparFiltro, mas sem resetar exibirPesquisaAvancada

          // Carrega as configurações de página
          this.carregarQtdPorPagina();
          
          // Carrega os valores para os selects (tipos, orgaos)
          // `await` aqui é crucial para garantir que os dados estejam disponíveis
          await this.carregarValoresFiltro();
          
          // Se o orgaoSlug está na URL, ele tem precedência
          if (to.params.orgaoSlug) {
            await this.processarOrgaoPorSlug(to.params.orgaoSlug);
            this.carregarAtoInfralegal(); // Dispara a busca após processar o slug
          } else {
            // Se não há slug ou o slug foi removido, carrega atos baseado nas queries
            this.carregarAtoInfralegal();
          }
        }
      },
    },
  },
  methods: {
    async checarStatusNorma() {
      try {
        // Reutiliza a API de legislação para checar o status do Norma
        const api = new (require('../../services/LegislacaoApi').default)();
        const statusNorma = await api.normaStatus();
        this.statusNorma = statusNorma.status;
      } catch (e) {
        // Em dev, manter o input visível conforme InputSemantico
        this.statusNorma = process.env.NODE_ENV === 'development' ? 'ok' : '';
      }
    },
    adicionarOperadorTermo(operador) {
      if (!this.termo) {
        this.termo = '';
      }
      this.termo += ` ${operador} `;
    },
    parseBoolean(value) {
      if (typeof value === 'boolean') return value;
      if (typeof value === 'string') {
        const v = value.trim().toLowerCase();
        if (v === 'true' || v === '1' || v === 'yes' || v === 'on') return true;
        if (v === 'false' || v === '0' || v === 'no' || v === 'off' || v === '') return false;
      }
      if (typeof value === 'number') return value !== 0;
      return false;
    },
    scrollParaResultados() {
      this.$nextTick(() => {
        this.$scrollTo("#resultados", 700, {
          offset: 100,
          cancelable: false,
        });
      });
    },
    removerItemFiltro({ key, id }) {
      const nextQuery = { ...this.$route.query };

      const normalizarArray = (valor) => {
        if (valor === undefined || valor === null || valor === '') {
          return [];
        }
        if (Array.isArray(valor)) {
          return valor.map((item) => item.toString());
        }
        return valor.toString().split(',');
      };

      if (key === 'tipo_ato_infralegal' && id !== undefined) {
        const idStr = id.toString();

        this.tiposSelecionados = this.tiposSelecionados.filter(
          (tipo) => tipo.id.toString() !== idStr
        );
        this.tiposSelecionadosMobile = [...this.tiposSelecionados];

        this.filtro.tipo_ato_infralegal = this.tiposSelecionados.map((tipo) => tipo.id);

        const valoresAtuais = normalizarArray(nextQuery.tipo_ato_infralegal);
        const atualizados = valoresAtuais.filter((valor) => valor !== idStr);
        if (atualizados.length > 0) {
          nextQuery.tipo_ato_infralegal = atualizados;
        } else {
          delete nextQuery.tipo_ato_infralegal;
        }
      } else if (key === 'orgao_emissor') {
        this.orgaoSelecionado = null;
        this.filtro.orgao_emissor = null;
        delete nextQuery.orgao_emissor;
        // O setor só faz sentido dentro do órgão
        this.filtro.setor = null;
        delete nextQuery.setor;
      } else if (key === 'ano') {
        this.filtro.ano = null;
        delete nextQuery.ano;
      } else if (key === 'periodo_data') {
        this.filtro.periodo_inicial_data = null;
        this.filtro.periodo_final_data = null;
        delete nextQuery.periodo_inicial_data;
        delete nextQuery.periodo_final_data;
      } else if (key === 'periodo_inicial_vigencia') {
        // Limpa APENAS os campos relacionados ao INÍCIO da vigência
        this.filtro.periodo_inicial_vigencia_inicio = null;
        this.filtro.periodo_inicial_vigencia_fim = null;
        // Remove apenas as chaves que começam com periodo_inicial_vigencia
        Object.keys(nextQuery).forEach(queryKey => {
          if (queryKey.startsWith('periodo_inicial_vigencia')) {
            delete nextQuery[queryKey];
          }
        });
      } else if (key === 'periodo_final_vigencia') {
        // Limpa APENAS os campos relacionados ao FIM da vigência
        this.filtro.periodo_final_vigencia_inicio = null;
        this.filtro.periodo_final_vigencia_fim = null;
        // Remove apenas as chaves que começam com periodo_final_vigencia
        Object.keys(nextQuery).forEach(queryKey => {
          if (queryKey.startsWith('periodo_final_vigencia')) {
            delete nextQuery[queryKey];
          }
        });
      } else {
        if (Array.isArray(this.filtro[key])) {
          this.filtro[key] = [];
        } else if (Object.prototype.hasOwnProperty.call(this.filtro, key)) {
          this.filtro[key] = null;
        }
        delete nextQuery[key];
      }

      // Mantém indicador de busca avançada se ainda restarem filtros
      const possuiFiltrosAvancados = Object.entries(nextQuery).some(([chave, valor]) => {
        if (['pagina', 'qtd_por_pagina', 'busca_avancada', 'termo'].includes(chave)) {
          return false;
        }
        if (Array.isArray(valor)) {
          return valor.length > 0;
        }
        return valor !== undefined && valor !== null && valor !== '';
      });

      if (possuiFiltrosAvancados) {
        nextQuery.busca_avancada = 1;
      } else {
        delete nextQuery.busca_avancada;
      }

      this.$router
        .push({
          name: 'PesquisaAtoInfralegal',
          params: { orgaoSlug: this.$route.params.orgaoSlug || undefined },
          query: nextQuery,
        })
        .then(() => {
          this.scrollParaResultados();
        })
        .catch((err) => {
          if (!err || err.name === 'NavigationDuplicated') {
            this.scrollParaResultados();
          } else {
            throw err;
          }
        });
    },
    async processarOrgaoPorSlug(slug) {
      this.carregando = true;
      this.erro = false;
      try {
        const orgaoEncontrado = await this.orgaoAtoInfralegalApi.getOrgaoBySlug(slug);

        if (orgaoEncontrado) {
          this.filtro.orgao_emissor = orgaoEncontrado.id;
          this.orgaoSelecionado = orgaoEncontrado;
          this.exibirPesquisaAvancada = true; // Força a exibição da pesquisa avançada
          this.termo = null; // Limpa o termo de busca simples
        } else {
          console.warn(`Órgão com slug "${slug}" não encontrado.`);
          this.filtro.orgao_emissor = null;
          this.orgaoSelecionado = null;
          this.erro = true; // Define erro se o slug não corresponder a um órgão
        }
      } catch (err) {
        console.error("Erro ao processar slug do órgão:", err);
        this.erro = true;
      } finally {
        this.carregando = false;
      }
    },
    adicionarOperador(operador) {
      if (this.termo == null) {
        this.termo = "";
      }
      this.termo += ` ${operador} `;
    },
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil(
          (this.qtd_por_pagina * this.pagina) / novaQtdPagina
        );

        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    fazerBuscaSimples: function (termo) {
      // Limpa os filtros de pesquisa avançada ao fazer uma busca simples
      this.limparFiltro();
      this.termo = termo; // Garante que o termo esteja atualizado

      if (this.semantico == true && termo.length <= 0) {
        return;
      }

      this.$router.push({
        name: "PesquisaAtoInfralegal",
        // Removido params: { orgaoSlug: undefined } para limpar o slug da URL se houver
        query: {
          termo: this.termo, // Usar this.termo para garantir o valor atual
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          semantico: this.semantico,
        },
      })
      .then(() => {
        this.scrollParaResultados();
      })
      .catch((err) => {
        if (!err || err.name === "NavigationDuplicated") {
          this.scrollParaResultados();
        } else {
          throw err;
        }
      });
    },
    fazerBuscaAvancada: function (event, flag) {
      event.preventDefault();

      if (this.semantico == true && this.filtro.conteudo.length <= 0) {
        return;
      }

      if (flag == true) {
        this.filtro.tipo_ato_infralegal = null;
        this.tiposSelecionados = []; // CORREÇÃO
        this.filtro.orgao_emissor = null;
        this.orgaoSelecionado = null;
      } else {
        if (this.tiposSelecionados && this.tiposSelecionados.length > 0) {
          this.filtro.tipo_ato_infralegal = this.tiposSelecionados.map(
            (tipo) => tipo.id
          );
        } else {
          this.filtro.tipo_ato_infralegal = [];
        }

        if (this.orgaoSelecionado) {
          this.filtro.orgao_emissor = this.orgaoSelecionado.id;
        } else {
          this.filtro.orgao_emissor = null;
        }
      }

      // O formulário não tem campo de setor: ele só é mantido enquanto o
      // órgão for o mesmo que veio da consulta por órgão.
      const orgaoDaRota = [].concat(this.getParam("orgao_emissor") || [])[0];
      if (!this.filtro.orgao_emissor || String(this.filtro.orgao_emissor) !== String(orgaoDaRota)) {
        this.filtro.setor = null;
      }

      // Limpa o termo de busca simples se a avançada for usada
      this.termo = null;
      this.$router
        .push({
          name: "PesquisaAtoInfralegal",
          params: { orgaoSlug: undefined },
          query: {
            ...this.filtro,
            ...this.convertePeriodosDatasParaString(),
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
            busca_avancada: 1,
            semantico: this.semantico,
          },
        })
        .then(() => {
          this.scrollParaResultados();
        })
        .catch((err) => {
          if (!err || err.name === "NavigationDuplicated") {
            this.scrollParaResultados();
          } else {
            throw err;
          }
        });
    },
    mudouPagina: function (page) {
      this.pagina = page;

      let termoParam = {};
      if (this.termo) {
        termoParam = { termo: this.termo };
      }

      this.semantico = this.parseBoolean(this.getParam("semantico"));

      // Constrói o objeto de filtro a partir do estado atual do componente (this.filtro)
      const filtroParaRota = {
        numero: this.filtro.numero,
        conteudo: this.filtro.conteudo,
        tipo_ato_infralegal: this.filtro.tipo_ato_infralegal,
        categoria_ato_infralegal: this.filtro.categoria_ato_infralegal,
        orgao_emissor: this.filtro.orgao_emissor,
        setor: this.filtro.setor,
        ano: this.filtro.ano,
        ementa: this.filtro.ementa,
        ...this.convertePeriodosDatasParaString(),
      };

      this.$router.push({
        name: "PesquisaAtoInfralegal",
        params: { orgaoSlug: this.$route.params.orgaoSlug || undefined }, // Mantém o slug se existir
        query: {
          ...filtroParaRota,
          ...termoParam,
          semantico: this.semantico,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: this.exibirPesquisaAvancada ? 1 : undefined,
        },
      });
        this.$scrollTo("#resultados", 0, {
          offset: -100,
          cancelable: false,
      });
    },
    carregarValoresFiltro: async function () {
      try {
        // Se já tem dados e não houve erro, e não é uma recarga por erro,
        // apenas atualiza os seletores sem fazer nova chamada API.
        if (this.tipos_atos_infralegais.length > 0 && this.orgaos_atos_infralegais.length > 0 && !this.erroFiltros) {
            this.atualizarSeletoresBaseadoNosParametrosDaUrl();
            return;
        }

        this.carregandoFiltros = true;
        this.erroFiltros = false;

        // Assegura que as APIs estão inicializadas.
        // Isso é uma redundância para o `created`, mas aumenta a robustez.
        if (!this.tipoAtoInfralegalApi) this.tipoAtoInfralegalApi = new TipoAtoInfralegalApi();
        if (!this.orgaoAtoInfralegalApi) this.orgaoAtoInfralegalApi = new OrgaoAtoInfralegalApi();

        this.tipos_atos_infralegais =
          await this.tipoAtoInfralegalApi.getTiposAtoInfralegal();

        if (this.filtro.tipo_ato_infralegal) {
          const filtros = Array.isArray(this.filtro.tipo_ato_infralegal)
            ? this.filtro.tipo_ato_infralegal
            : [this.filtro.tipo_ato_infralegal];

          this.tiposSelecionados = this.tipos_atos_infralegais.filter((tipo) =>
            filtros.some((filtro_tipo) => filtro_tipo == tipo.id)
          );
        }

        var orgaos = await this.orgaoAtoInfralegalApi.getOrgaosAtoInfralegal();
        this.orgaos_atos_infralegais = orgaos;
        this.orgaos_atos_infralegais_filtrados = this.orgaos_atos_infralegais;


        
        // Agora que os dados foram carregados, atualiza os seletores
        this.atualizarSeletoresBaseadoNosParametrosDaUrl();

        
        // Agora que os dados foram carregados, atualiza os seletores
        this.atualizarSeletoresBaseadoNosParametrosDaUrl();

        this.carregandoFiltros = false;
      } catch (err) {
        console.error("Erro ao carregar valores de filtro:", err);
        this.carregandoFiltros = false;
        this.erroFiltros = true;
        this.tipos_atos_infralegais = [];
        this.orgaos_atos_infralegais = [];
      }
    },
    // Novo método para evitar duplicação de código na atualização de seletores
    atualizarSeletoresBaseadoNosParametrosDaUrl() {
        // Atualiza os seletores baseados nos query parameters da URL
        const orgaoEmissorParam = this.getParam("orgao_emissor");
        if (orgaoEmissorParam) {
            const filtroOrgaos = Array.isArray(orgaoEmissorParam)
                ? orgaoEmissorParam.map(id => parseInt(id))
                : [parseInt(orgaoEmissorParam)];

          const selecionados = this.buscarOrgaos(
            this.orgaos_atos_infralegais,
                filtroOrgaos
            );

          this.orgaoSelecionado =
            selecionados.length > 0 ? selecionados[0] : null;
          this.orgaoSelecionado =
            selecionados.length > 0 ? selecionados[0] : null;
            this.filtro.orgao_emissor = this.orgaoSelecionado ? this.orgaoSelecionado.id : null;
            this.exibirPesquisaAvancada = true; // Exibe pesquisa avançada se houver filtro de órgão na query
        } else {
          this.orgaoSelecionado = null;
          this.filtro.orgao_emissor = null;
        }

        const tipoAtoInfralegalParam = this.getParam("tipo_ato_infralegal");
        if (tipoAtoInfralegalParam) {
            const filtroTipos = Array.isArray(tipoAtoInfralegalParam)
                ? tipoAtoInfralegalParam.map(id => parseInt(id))
                : [parseInt(tipoAtoInfralegalParam)];
            
            this.tipoSelecionado = this.tipos_atos_infralegais.filter((tipo) =>
                filtroTipos.some((filtro_tipo) => filtro_tipo == tipo.id)
          );
            this.filtro.tipo_ato_infralegal = this.tipoSelecionado.length > 0 ? this.tipoSelecionado[0].id : null;
            this.exibirPesquisaAvancada = true; // Exibe pesquisa avançada se houver filtro de tipo na query
        } else {
            this.tipoSelecionado = null;
            this.filtro.tipo_ato_infralegal = null;
        }
    },
    buscarOrgaos(orgaos, filtros) {
      let selecionados = [];

      orgaos.forEach((orgao) => {
        if (filtros.some((filtro_orgao) => filtro_orgao == orgao.id)) {
          selecionados.push(orgao);
        }

        if (orgao.children && Array.isArray(orgao.children)) {
          selecionados = selecionados.concat(
            this.buscarOrgaos(orgao.children, filtros)
          );
        }
      });

      return selecionados;
    },
    getLabelItem: function (item) {
      if (item && !Array.isArray(item)) {
        return item.nome;
      } else if (item && Array.isArray(item)) {
        return item.map((elemento) => elemento.nome).join(', ');
      }
      return '';
    },
    // Nomes dos setores (Unidade Responsável) para o chip de parâmetros da
    // busca. Só consulta a API quando a pesquisa filtra por um setor.
    async carregarSetores() {
      if (!this.filtro.setor || this.setores_atos_infralegais.length > 0) {
        return;
      }
      try {
        const orgaos = await this.atoInfralegalApi.getOrgaos();
        this.setores_atos_infralegais = [].concat(...orgaos.map((orgao) => orgao.children || []));
      } catch (err) {
        if (!this.atoInfralegalApi.isCancel(err)) {
          console.error("Erro ao carregar setores:", err);
        }
      }
    },
    onOrgaoSelecionado(orgao) {
      this.orgaoSelecionado = orgao;
      this.filtro.orgao_emissor = orgao ? orgao.id : null;
    },
    carregarAtoInfralegal: async function () {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;
        this.armazenarQtdPorPagina();

        this.pagina = parseInt(this.getParam("pagina") || 1);
        this.termo = this.getParam("termo");
        this.semantico = this.parseBoolean(this.getParam("semantico"));
        
        // Define os valores do filtro a partir dos query params, se houver
        // Os seletores (Multiselect) já atualizam this.filtro.orgao_emissor/tipo_ato_infralegal
        // e processarOrgaoPorSlug() também faz isso.
        this.filtro.numero = this.getParam("numero");
        this.filtro.conteudo = this.getParam("conteudo");
        this.filtro.ano = this.getParam("ano");
        this.filtro.ementa = this.getParam("ementa");
        this.filtro.setor = this.getParam("setor") || null;
        this.carregarSetores();
        Object.assign(this.filtro, this.convertPeriodosStringParaDatas());
        
        // Se a busca avançada foi explicitamente ativada via query param (busca_avancada=1)
        // ou se algum filtro avançado (que não seja o termo de busca simples) está preenchido
        const buscaAvancadaParam = tryParseInt(this.getParam("busca_avancada"));
        this.exibirPesquisaAvancada = buscaAvancadaParam === 1 ||
                                      (this.filtro.numero ||
          this.filtro.conteudo ||
                                       this.filtro.tipo_ato_infralegal ||
          this.filtro.orgao_emissor ||
          this.filtro.ano ||
          this.filtro.ementa ||
          this.filtro.periodo_inicial_data ||
          this.filtro.periodo_final_data ||
          this.filtro.periodo_inicial_vigencia_inicio ||
          this.filtro.periodo_final_vigencia_inicio ||
          this.filtro.periodo_inicial_vigencia_fim ||
          this.filtro.periodo_final_vigencia_fim);
        
        if (this.atoInfralegalApi.cancelTokens.getAtosInfralegais) {
          this.atoInfralegalApi.cancelTokens.getAtosInfralegais.cancel();
        }

        let params = {
          qtd_por_pagina: this.qtd_por_pagina,
          page: this.pagina,
        };

        if (this.exibirPesquisaAvancada) { // Usa o estado atual da exibição da busca avançada
            params = {
                ...params,
                ...this.filtro,
                ...this.convertePeriodosDatasParaString(), // Garante que as datas vão como string
            };
            // O termo deve ser nulo se for busca avançada
            delete params.termo;
        } else {
          let data = await this.atoInfralegalApi.getAtosInfralegais({
            termo: this.termo,
            semantico: this.semantico,
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          });
          this.atosInfralegais = data.resultados;
          this.totalResultados = data.total_resultados;
          this.totalResultadosTexto = data.total_resultados.toLocaleString();
        }

        if (this.exibirPesquisaAvancada) {
          const data = await this.atoInfralegalApi.getAtosInfralegais(params);
          this.atosInfralegais = data.resultados;
          this.totalResultados = data.total_resultados;
          this.totalResultadosTexto = data.total_resultados.toLocaleString();
        }
        this.carregando = false;
      } catch (err) {
        if (this.atoInfralegalApi.isCancel(err)) {
          return;
        }
        console.error("Erro ao carregar Ato Infralegal:", err);
        this.carregando = false;
        this.erro = true;
      }
    },
    limparFiltro: function (resetAdvancedSearch = true) {
      this.filtro = {
        numero: null,
        conteudo: null,
        tipo_ato_infralegal: null,
        categoria_ato_infralegal: null,
        orgao_emissor: null,
        setor: null,
        ementa: null,
        autor: null,
        ano: null,
        periodo_inicial_data: null,
        periodo_final_data: null,
        periodo_inicial_vigencia_inicio: null,
        periodo_final_vigencia_inicio: null,
        periodo_inicial_vigencia_fim: null,
        periodo_final_vigencia_fim: null,
      };
      this.tiposSelecionados = [];
      this.tiposSelecionados = [];
      this.termo = null;
      this.tipoSelecionado = null;
      this.orgaoSelecionado = null;
      this.semantico = false;
      if (resetAdvancedSearch) {
          this.exibirPesquisaAvancada = false; // Define como false ao limpar, a menos que especificado
      }
    },
    convertePeriodosDatasParaString: function () {
      return {
        periodo_inicial_data: this.filtro.periodo_inicial_data
          ? format(this.filtro.periodo_inicial_data, "yyyy-MM-dd")
          : null,
        periodo_final_data: this.filtro.periodo_final_data
          ? format(this.filtro.periodo_final_data, "yyyy-MM-dd")
          : null,
        periodo_inicial_vigencia_inicio: this.filtro
          .periodo_inicial_vigencia_inicio
          ? format(this.filtro.periodo_inicial_vigencia_inicio, "yyyy-MM-dd")
          : null,
        periodo_final_vigencia_inicio: this.filtro.periodo_final_vigencia_inicio
          ? format(this.filtro.periodo_final_vigencia_inicio, "yyyy-MM-dd")
          : null,
        periodo_inicial_vigencia_fim: this.filtro.periodo_inicial_vigencia_fim
          ? format(this.filtro.periodo_inicial_vigencia_fim, "yyyy-MM-dd")
          : null,
        periodo_final_vigencia_fim: this.filtro.periodo_final_vigencia_fim
          ? format(this.filtro.periodo_final_vigencia_fim, "yyyy-MM-dd")
          : null,
      };
    },
    convertPeriodosStringParaDatas: function () {
      const periodo_inicial_data = this.getParam("periodo_inicial_data");
      const periodo_final_data = this.getParam("periodo_final_data");
      const periodo_inicial_vigencia_inicio = this.getParam(
        "periodo_inicial_vigencia_inicio"
      );
      const periodo_final_vigencia_inicio = this.getParam(
        "periodo_final_vigencia_inicio"
      );
      const periodo_inicial_vigencia_fim = this.getParam(
        "periodo_inicial_vigencia_fim"
      );
      const periodo_final_vigencia_fim = this.getParam(
        "periodo_final_vigencia_fim"
      );

      return {
        periodo_inicial_data: periodo_inicial_data
          ? parseISO(periodo_inicial_data)
          : null,
        periodo_final_data: periodo_final_data
          ? parseISO(periodo_final_data)
          : null,
        periodo_inicial_vigencia_inicio: periodo_inicial_vigencia_inicio
          ? parseISO(periodo_inicial_vigencia_inicio)
          : null,
        periodo_final_vigencia_inicio: periodo_final_vigencia_inicio
          ? parseISO(periodo_final_vigencia_inicio)
          : null,
        periodo_inicial_vigencia_fim: periodo_inicial_vigencia_fim
          ? parseISO(periodo_inicial_vigencia_fim)
          : null,
        periodo_final_vigencia_fim: periodo_final_vigencia_fim
          ? parseISO(periodo_final_vigencia_fim)
          : null,
      };
    },
    tooglePesquisaAvancada: function () {
      this.exibirPesquisaAvancada = !this.exibirPesquisaAvancada;
    },
    abrirDadosAbertos: function (format) {
      if (
        this.totalResultados == undefined ||
        this.totalResultados == null ||
        this.totalResultados > 1000
      ) {
        alert(
          "O download dos dados é limitado a 1000 registros. Refaça sua consulta utilizando os filtros disponíveis."
        );
      } else {
        const params = new URLSearchParams({
          numero: this.getParam("numero") || "",
          conteudo: this.getParam("conteudo") || "",
          tipo_ato_infralegal: this.getParam("tipo_ato_infralegal") || "",
          categoria_ato_infralegal:
            this.getParam("categoria_ato_infralegal") || "",
          orgao_emissor: this.getParam("orgao_emissor") || "",
          setor: this.getParam("setor") || "",
          ano: this.getParam("ano") || "",
          periodo_inicial_data: this.getParam("periodo_inicial_data") || "",
          periodo_final_data: this.getParam("periodo_final_data") || "",
          periodo_inicial_vigencia_inicio:
            this.getParam("periodo_inicial_vigencia_inicio") || "",
          periodo_final_vigencia_inicio:
            this.getParam("periodo_final_vigencia_inicio") || "",
          periodo_inicial_vigencia_fim:
            this.getParam("periodo_inicial_vigencia_fim") || "",
          periodo_final_vigencia_fim:
            this.getParam("periodo_final_vigencia_fim") || "",
          termo: this.getParam("termo") || "",
          ementa: this.getParam("ementa") || "",
          semantico: this.parseBoolean(this.getParam("semantico")) || "",
        }).toString();
        window.open(
          `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/atos_infralegais/dados_abertos.${format}?${params}`,
          "_blank"
        );
      }
    },
    armazenarQtdPorPagina() {
      localStorage.setItem(
        "qtd_por_pagina_ato_infralegal",
        this.qtd_por_pagina
      );
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_ato_infralegal");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
    abrirTipoMobileDropdown() {
      this.tiposSelecionadosMobile = [...this.tiposSelecionados];
      this.showTipoMobileDropdown = true;
    },
    closeTipoMobileDropdown() {
      this.showTipoMobileDropdown = false;
      this.tiposSelecionadosMobile = [...this.tiposSelecionados];
    },
    toggleTipoSelecionado(option) {
      const idx = this.tiposSelecionadosMobile.findIndex(
        (sel) => sel.id === option.id
      );
      if (idx === -1) {
        this.tiposSelecionadosMobile.push(option);
      } else {
        this.tiposSelecionadosMobile.splice(idx, 1);
      }
    },
    aplicarTipoSelecionados() {
      this.tiposSelecionados = [...this.tiposSelecionadosMobile];
      this.showTipoMobileDropdown = false;
    },
    abrirOrgaoMobileDropdown() {
      this.orgaoSelecionadoMobile = this.orgaoSelecionado
        ? { ...this.orgaoSelecionado }
        : null;
      this.showOrgaoMobileDropdown = true;
      this.orgaoFiltroTexto = "";
    },
    closeOrgaoMobileDropdown() {
      this.showOrgaoMobileDropdown = false;
      this.orgaoFiltroTexto = "";
    },
    selectOrgaoOption(option) {
      this.orgaoSelecionadoMobile = option;
      this.orgaoSelecionado = option;
      this.showOrgaoMobileDropdown = false;
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados != undefined &&
        this.totalResultados != null &&
        this.qtd_por_pagina != null &&
        this.qtd_por_pagina != undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
    orgaosFormatados() {
      return this.orgaos_atos_infralegais;
    },
    orgaosFiltradosMobile() {
      if (!this.orgaoFiltroTexto) return this.orgaos_atos_infralegais;
      const texto = this.orgaoFiltroTexto.toLowerCase().normalize("NFD");
      return this.orgaos_atos_infralegais.filter((option) =>
        option.nome.toLowerCase().normalize("NFD").includes(texto)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
  background-color: #ffb24e;
  color: #115810;
  margin: 0; /* Remove a margem interna do h1 */
  padding: 0 0.3rem;
  display: inline;
  border-radius: 12px; /* Arredonda os cantos */
  line-height: normal; /* Ajusta a altura da linha */
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}

.titulo-pagina {
  display: flex;
  align-items: center;
  gap: 1rem;
  // margin: 2rem 0 1.5rem 0;
}

.triangulo-play {
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 25px solid darkgreen;
}
/* Alinha o título com os demais blocos em telas até 1023px */
@media screen and (max-width: 1023px) {
  .titulo-pagina {
    margin-left: 1rem;
  }
}
.busca-info {
  display: block;
  margin: 0 0 1rem 0;
  padding: 0;
  .info-texto {
    margin: 0.5rem 0;
    color: #ffa900;
    font-size: 0.93rem;
    span {
      font-weight: bold;
    }
  }
}
.tooltip {
  display: flex;
  width: max-content;
  margin: 1rem 0 1rem 0;
  .button {
    margin: 0.3rem 0.7rem 0 0;
    font-size: 0.9rem;
    background-color: #edf2ee;
    border: none;
    border-radius: 0.3rem;
    padding: 0.3rem 0.5rem;
    box-shadow: 1px 2px 1px #ffa900;
    cursor: pointer;
  }
  .button:hover {
    box-shadow: 0px 0px 0px;
    padding: 0.27rem 0.47rem;
    font-size: 0.87rem;
    background-color: #ffa900;
  }
  .container-tooltip {
    position: relative;
  }
  .modal {
    display: block;
    width: 16rem;
    z-index: 1000;
    position: absolute;
    max-width: 20rem;
    font-size: 0.9rem;
    background-color: #edf2ee;
    box-shadow: 3px 5px 5px #ffa900;
    padding: 0.3rem 1rem;
    border-radius: 0.5rem;

    span {
      font-weight: bold;
    }
  }
  .modal-1 {
    display: none;
  }
  .modal-2 {
    display: none;
  }
  .modal-3 {
    display: none;
  }
  .modal-4 {
    display: none;
  }
}

@media screen and (min-width: 320px) and (max-width: 425px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 426px) and (max-width: 1024px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 20vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 25vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 2560px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 15vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.8s;
  -webkit-transition-duration: 0.8s;
  -o-transition-duration: 0.8s;
  transition-duration: 0.8s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.submit-busca-simples {
  cursor: pointer;
}

/* removido h1 antigo para manter o novo estilo igual ao da legislação */
.pesquise {
  background-color: #115810;
  padding: 0.5rem 1rem 1.5rem;
  /* Linha com input à esquerda e operadores à direita */
  .linha-input-operadores {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    // gap: 1.6rem; /* aproxima input dos botões */
    align-items: start; /* alinha topo dos elementos */
  }
  /* Reduz largura máxima do input para evitar sobreposição */
  .linha-input-operadores .row1 {
    max-width: none; /* permite ocupar toda a coluna */
    width: 100%;
    min-width: 0; /* evita limitar em telas menores */
  }
  .lado-direito {
    display: flex;
    flex-direction: column; /* coloca "Pesquisa avançada" abaixo dos botões */
    align-items: center; /* mantém alinhado à direita do input */
    gap: 0.2rem; /* aproxima o botão dos operadores */
    min-height: 3.2rem;
    margin-top: 2.5rem; /* sobe o bloco inteiro (operadores + pesquisa avançada) */
  }
  .lado-direito .botao {
    margin: 0; /* abaixo, sem margem lateral */
    margin-top: auto; /* sobe levemente o botão */
  }
  label {
    color: white;
    font-size: 0.9rem;
  }
  input {
    border: none;
    width: calc(100% - 0.8rem);
    height: 2rem;
    border-radius: 0.2rem;
    border: none;
    padding-left: 0.5rem;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.03rem;
    color: black;
  }
  form {
    .campo-preenchido {
      background-color: #fffed4;
      // border: solid .15rem #ffa900;
      // box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -moz-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -webkit-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
    }
  }

  .botao {
    button {
      background-color: #ffb24e;
      border-radius: 0.2rem;
      border: none;
      font-size: 0.85rem;
      font-family: "Poppins-Bold";
      color: #0e489f;
      height: 1.2rem; /* igual aos operadores */
      padding: 0 0.25rem; /* apenas horizontal */
      margin-top: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 0.03rem;
      // margin-left: 0.25rem;
      span {
        font-size: 0.9rem;
      }
    }
    button:focus {
      box-shadow: none;
      outline: none;
      cursor: pointer;
    }
  }
  .botoes {
    float: right;
    margin: 1rem 0.2rem 1rem auto;
    button {
      margin-left: 1rem;
      padding: 0.1rem 2rem;
      font-family: "Poppins-Medium";
      font-size: 0.9rem;
    }
    button:first-child {
      background: transparent;
      border: white solid 0.15rem;
      color: white;
      padding: 0.1rem 2rem;
      cursor: pointer;
    }
    button:last-child {
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      cursor: pointer;
    }
  }

  select {
    width: calc(100% - 0.2rem);
    height: 2rem;
    border: none;
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    background-color: white;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.04rem;
  }

  h2 {
    color: white;
    font-family: "Poppins-Bold";
    font-size: 1.1rem;
    display: inline-table;
    // border-bottom: #ffa900 solid 0.15rem;
    margin: 0rem;
    padding-right: 1rem;
    width: fit-content;
  }
  .row2 {
    display: grid;
    .row2mobile {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      margin-bottom: 4px;
      margin-top: 4px;
    }
  }
  .grupo {
    border: #ffa900 solid 0.15rem;
    margin: 0.5rem 0rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    .data {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      .mx-datepicker {
        width: 100%;
      }
    }
    p {
      margin: 0rem;
      padding: 0rem;
      color: white;
    }
  }
  .item {
    width: 100%;
    display: grid;
    margin: 0.5rem 0rem;
    height: fit-content;
  }
  .seta {
    img {
      width: 5rem;
      position: absolute;
      right: 1.5rem;
      margin-top: 0rem;
    }
    .t-preto {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .pesquise {
    .linha-input-operadores {
      grid-template-columns: 1fr; /* empilha em telas pequenas */
    }
    .lado-direito {
      align-items: flex-start;
    }
  }
}

.campo-resultados {
  margin: 1rem;
  h2 {
    color: #083e07;
    font-family: 'Anton', sans-serif;
    font-size: 1.1rem;
    margin: 1.5rem 0rem 0rem 1rem;
    display: table;
    padding-right: 1rem;
  }
  .dados-abertos {
    width: fit-content;
    margin: 1rem auto 0;
    padding: 0;
    p {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      margin: 0;
      background-color: #d3d4d3;
      padding: 0.2rem 0.75rem;
      font-size: 0.9rem;
      font-family: "Poppins", sans-serif;
      color: #083e07;
      border-radius: 0.2rem;
      line-height: 1.2;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
    span,
    a {
      margin: 0;
    }
    a {
      text-decoration: none;
      color: #083e07;
      font-family: "Poppins-Medium";
      cursor: pointer;
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
  .nav-resultados {
    margin-bottom: 2rem;
  }
  .nresultados {
    margin: 0rem auto 2rem;
    p {
      font-size: 0.9rem;
      margin: 0rem 0rem -2rem 1rem;
      strong {
        font-family: "Poppins-Medium";
        color: #083e07;
      }
    }
  }
  .npagina {
    margin: 0.5rem 1rem 0.5rem 1rem;
    label {
      font-family: "Poppins-Medium";
      font-weight: 900;
      margin-right: 0.5rem;
      color: #2c3f2b;
      font-size: 0.9rem;
    }
    select {
      border: none;
      background-color: #d3d4d3;
      font-size: 0.9rem;
      margin-top: 0.5rem;
    }
  }
}

@media screen and (min-width: 31rem) {
  .nav-resultados {
    margin-bottom: 0rem !important;
  }
}
@media screen and (min-width: 64rem) {
  h1 {
    margin-left: 0rem;
    font-size: 1.75rem;
  }
  h2 {
    font-size: 1.3rem !important;
  }

  .pesquise {
    padding-bottom: 2rem !important;

    h2 {
      margin-top: 1rem;
      // margin-bottom: 0.5rem;
    }
    .label-busca {
      text-align: left;
      margin-bottom: 0.3rem;
    }
    .row2 {
      grid-template-columns: calc(50% - 1%) calc(50% - 1%);
      gap: 2%;
      .item {
        input {
          padding-right: 0.25rem;
        }
      }
    }
    .grupo {
      padding: 0.5rem 2rem;
    }
    .botoes {
      margin-right: 0rem;
      margin-top: 0.5rem;
      button {
        font-size: 1rem;
        padding: 0.1rem 4rem !important;
        border-radius: 0.2rem;
      }
    }
    .seta {
      img {
        right: 4.7rem;
        margin-top: 0.5rem;
      }
    }
  }
  .campo-resultados {
    // background-color: #efeeed;
    h2 {
      margin-left: 0rem;
      font-family: 'Anton', sans-serif;
      font-size: 1.5rem;
      color: #083e07;
    }
    .dados-abertos {
      width: fit-content;
      margin: -2rem 1rem 0rem auto;
      p {
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 0 0.5rem;
        height: 1.2rem;
      }
      span,
      a {
        font-size: 0.8rem;
      }
    }
    .npagina {
      text-align: right;
      label {
        font-size: 0.8rem;
      }
    }
    .nresultados {
      max-width: 17rem;
      text-align: left;
      margin: 0rem 0rem 2rem;
      p {
        font-size: 0.8rem;
        margin: -1.5rem 0rem 0rem 0rem;
        text-align: left;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }
  }
}
.alto-contraste {
  .pesquise {
    background-color: #115810;
    .seta {
      .t-branco {
        display: none;
      }
      .t-preto {
        display: block;
      }
    }

    .botoes {
      button:last-child {
        background-color: #ffa900;
        color: #0d2b10;
        font-family: "Poppins-Medium";
      }
    }
  }
  .nav-resultados {
    h2 {
      color: white;
    }
  }
  .npagina {
    label {
      color: white !important;
    }
  }
  .nresultados {
    color: white;
    
    p {
      color: white !important;
      
      strong {
        color: white !important;
      }
    }
  }
}
.pesquise .multiselect__content-wrapper {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  top: auto !important;
  max-height: 50vh !important;
  min-height: 100px;
  overflow-y: auto !important;
  z-index: 9999 !important;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.multiselect__content {
  max-height: 50vh !important;
  height: auto !important;
  overflow-y: auto !important;
}
.mobile-dropdown-modal {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-dropdown-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 400px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.mobile-dropdown-header {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  text-align: right;
  background: #f5f5f5;
}
.mobile-dropdown-header button {
  background: #ffa900;
  color: #2c3f2b;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
}
.mobile-dropdown-list {
  flex: 1;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.mobile-dropdown-list li {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.2s;
}
.mobile-dropdown-list li.selected,
.mobile-dropdown-list li:hover {
  background: #083e07;
  color: #fff;
}

::v-deep .multiselect__option--selected,
::v-deep .multiselect__option--highlight {
  background-color: #115810 !important;
  color: #fff !important;
}

::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background-color: #115810 !important;
  color: #fff !important;
}

::v-deep .multiselect__tag {
  background-color: #115810 !important;
  color: #fff !important;
  border: none !important;
}

::v-deep .multiselect__tag-icon,
::v-deep .multiselect__tag-icon:after {
  color: #fff !important;
}

::v-deep .multiselect__tag-icon:hover,
::v-deep .multiselect__tag-icon:focus {
  background: rgba(0, 0, 0, 0.15) !important;
}
.mobile-multiselect-trigger {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px 0 8px;
  margin: 0;
  height: auto;
  min-height: 34px;
  width: 100%;
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.mobile-multiselect-trigger:after {
  content: "\25BC";
  margin-left: auto;
  color: #aaa;
}
.mobile-dropdown-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 1.1rem;
  outline: none;
  box-sizing: border-box;
}
.mobile-dropdown-apply {
  width: 100%;
  padding: 1rem;
  background: #083e07;
  color: #fff;
  border: none;
  border-top: 1px solid #eee;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  border-radius: 0 0 8px 8px;
  transition: background 0.2s;
}
.mobile-dropdown-apply:active {
  background: #368f6e;
}
.mobile-dropdown-list li input[type="checkbox"] {
  margin-right: 1rem;
  accent-color: #083e07;
}
.chip-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 2px;
}
.chip {
  display: block;
  background: #115810;
  color: #fff;
  border-radius: 12px;
  padding: 6px 10px;
  font-size: 0.95em;
  border: 1px solid #0d440c;
  white-space: normal;
  width: 100%;
  box-sizing: border-box;
}
.mobile-multiselect-trigger .chip-list {
  max-height: 80px;
  overflow-y: auto;
  margin-bottom: 2px;
}
.mobile-multiselect-trigger {
  overflow: hidden;
}
.row2mobile {
  align-items: start;
}
.chip-list-mobile {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80px;
  margin-bottom: 2px;
  gap: 6px;
}
.chip-list-mobile .chip {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.tipo-nome-unico {
  display: block;
  width: 100%;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  font-weight: 600;
  color: #2c3f2b;
}

@media screen and (max-width: 768px) {
  .dados-abertos p {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    min-width: fit-content;
    font-size: 0.7rem !important;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
}
</style>
